import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

export default function NotFoundPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center p-md text-center">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
      >
        <h1>404</h1>
        <p className="mt-md text-fg-soft">
          Pagina pe care o cauți nu există.
        </p>
        <Link to="/" className="btn-primary mt-xl">
          Acasă
        </Link>
      </motion.div>
    </div>
  );
}
